import { config } from "virtual:tailwind-config";

export function getTailwindColor(color: string) {
  // @ts-expect-error - color is a string
  return config.theme?.colors?.[color]
}